<template>
    <modal @closed="handleClosed" class="pause-modal" custom-class="max-w-lg" :allowCancel="false">
        <h2 class="pause-modal--heading" v-text="heading"></h2>
        <p v-if="isPause" class="mb-4" v-text="message"></p>
        <p class="mb-4" v-text="$t('CANCEL_MODAL_TEXT')"></p>
        <button class="add-order-modal__button" v-text="$t('PAUSE_SUBSCRIPTION_DASHBOARD')" @click="goToDashboard()"></button>
    </modal>
</template>

<script>
import Modal from '@/components/structure/Modal';

export default {
    name: 'CannotPauseModal',
    components: { Modal },
    props: {
        isPause: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        heading() {
            return this.isPause ? this.$t('PAUSE_SUBSCRIPTION_MODAL') : this.$t('CANCEL_SUBSCRIPTION_MODAL');
        },
        message() {
            return this.isPause ? this.$t('PAUSE_SUBSCRIPTION_MODAL_1') : this.$t('CANCEL_SUBSCRIPTION_MODAL_1');
        },
    },
    methods: {
        handleClosed() {
            this.$store.commit('account/setCanPauseOrCancel', true);
        },
        goToDashboard() {
            this.$router.push({ name: 'account.dashboard' });
        },
    },
};
</script>

<style lang="scss" scoped>
    .pause-modal {
        text-align: center;
    }

    .pause-modal--heading {
        font-size: 25px;
        line-height: 30px;
    }
</style>
